var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconImport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13516_142860",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13516_142860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 14.3334C7.12401 14.3334 6.30065 14.1672 5.52989 13.8347C4.75913 13.5023 4.08867 13.0511 3.51853 12.4812C2.94837 11.9113 2.497 11.2412 2.16441 10.4707C1.83182 9.70032 1.66553 8.87714 1.66553 8.00118C1.66553 7.12523 1.83175 6.30187 2.16419 5.53112C2.49664 4.76035 2.94781 4.08989 3.51769 3.51975C4.08759 2.94959 4.75776 2.49822 5.52818 2.16563C6.29859 1.83304 7.12177 1.66675 7.99773 1.66675C8.87368 1.66675 9.69704 1.83297 10.4678 2.16542C11.2386 2.49786 11.909 2.94903 12.4792 3.51892C13.0493 4.08882 13.5007 4.75898 13.8333 5.5294C14.1659 6.29981 14.3322 7.12299 14.3322 7.99895C14.3322 8.87491 14.1659 9.69826 13.8335 10.469C13.5011 11.2398 13.0499 11.9102 12.48 12.4804C11.9101 13.0505 11.2399 13.5019 10.4695 13.8345C9.6991 14.1671 8.87592 14.3334 7.99996 14.3334ZM7.99884 13.3334C9.48773 13.3334 10.7488 12.8167 11.7822 11.7834C12.8155 10.7501 13.3322 9.48895 13.3322 8.00007H7.99884V2.66673C6.50996 2.66673 5.24884 3.1834 4.21551 4.21673C3.18218 5.25007 2.66551 6.51118 2.66551 8.00007C2.66551 9.48895 3.18218 10.7501 4.21551 11.7834C5.24884 12.8167 6.50996 13.3334 7.99884 13.3334Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImport);
export default __webpack_public_path__ + "static/media/icon-import.f23c9e622df4a98ed373e79ffc2805a2.svg";
export { ForwardRef as ReactComponent };